frontApp.itemsSlider = {
  init() {
    const $slider = $('.js-items-slider');
    if (!$slider.length) {
      return;
    }

    function lazyLoadSlideImage(sliderInstance) {
      const $visible = $(sliderInstance.visibleSlides);
      const $img = $visible.add($visible.prev()).add($visible.next()).find('.js-lazy-load').not('.loaded');
      if ($img.filter('.loaded').length !== $img.length && frontApp.lazyLoadGlobalInstance) {
        $.each($img, (idx, img) => {
          LazyLoad.load(img);
        });
      }
    }

    $.each($slider, function () {
      const $curSlider = $(this);
      const $nextEl = $curSlider.find('.js-items-slider__nav--next');
      const $prevEl = $curSlider.find('.js-items-slider__nav--prev');

      const sliderInstance = new Swiper($curSlider.find('.swiper')[0], {
        init: false,
        // loop: true, // Не работает корректно с lazy-load
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 16,
        slidesOffsetBefore: 16,
        watchSlidesProgress: true, // Нужно, чтобы получать visibleSlides из экземпляра
        noSwipingSelector: '.button, .button-favorite',
        watchOverflow: true,

        navigation: {
          nextEl: $nextEl[0],
          prevEl: $prevEl[0],
        },

        breakpoints: {
          576: {
            spaceBetween: 20,
          },
          992: {
            slidesPerView: $curSlider.closest('.js-search-page-slider').length ? 4 : 5,
            spaceBetween: 30,
            slidesOffsetBefore: 0,
          },
          1280: {
            slidesPerView: $curSlider.closest('.js-search-page-slider').length ? 4 : 6,
            spaceBetween: 30,
            slidesOffsetBefore: 0,
          },
          1600: {
            slidesPerView: $curSlider.closest('.js-search-page-slider').length ? 5 : 7,
            spaceBetween: 30,
            slidesOffsetBefore: 0,
          },
        },

        on: {
          transitionEnd() {
            lazyLoadSlideImage(sliderInstance);
          },
        },
      });

      sliderInstance.on('init', () => {
        $curSlider.addClass('is-loaded');
        lazyLoadSlideImage(sliderInstance);
      });

      sliderInstance.init();
    });
  },
};
